import BaseCard from './BaseCard';
import { CardType } from './CardType';
import Text from '../../Text';
import GameObject from '../../../GameObject/GameObject';
import Point from '../../../Utility/Point';
import TextComponent from '../../../Component/Render/Text';
import Game from '../../../Game';
import Renderable from '../../../Component/Renderable';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { CARD_DRAGONBONES_PATH } from 'Constants/Dragonbones';
import { SCORE_ROCK_CARD } from 'Constants/Score';
import CardStateHelper from 'State/Card/CardStateHelper';
import { CardModifierType } from './CardModifierType';

export default class RockCard extends BaseCard {
    public static PICKAXE_COUNT_TEXT_NAME: string = "pickaxe_count_text";

    public score: number = SCORE_ROCK_CARD;

    private pickaxesAmountText: Text;
    private prevPickaxesAmount: number;

    public onCreate(params: any): void {
        params.cardFrontTexture = 'rock';
        params.type = CardType.rock;
        params.dragonbonesName = 'pickaxe03_rock3_exp';
        params.armatureName = 'card_pickaxe_rock';
        params.armatureObjectName = 'rock_armature';

        this.prevPickaxesAmount = CardStateHelper.getCardsInPlay(Game.store.getState().levelState.cardsState, {
            requireCardModifierTypes: [
                CardModifierType.pickaxe,
            ]
        }).length

        this.pickaxesAmountText = GameObject.Instantiate(Text, {
            name: RockCard.PICKAXE_COUNT_TEXT_NAME,
            x: -18,
            y: -2,
            anchor: new Point(0.5, 0.5),
            text: `${this.prevPickaxesAmount}`,
            style: {
                fontFamily: 'FrancoisOne',
                fontSize: 48,
                fill: '#ffffff',
                stroke: '#522657',
                strokeThickness: 6,
            },
        });
        this.pickaxesAmountText.addComponent(Renderable);

        super.onCreate(params);

        this.addChild(this.pickaxesAmountText);
    }

    public updateModifiersVisibility(faceUp: boolean): void {
        this.pickaxesAmountText.getComponent(Renderable).visible = faceUp;
        this.getArmature().getComponent(Renderable).alpha = faceUp ? 1 : 0;
        super.updateModifiersVisibility(faceUp);
    }
    
    public static async preload(): Promise<void> {
        addDragonbonesResources('pickaxe03_rock3_exp', `${CARD_DRAGONBONES_PATH}/Pickaxe/`);
    }
}
